// skipcq: JS-W1028, JS-0128
import React from 'react';
import {
  Box,
  Button,
  Container,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import SplatsTable from './SplatsTable';
import { SPLAT_TYPES, getSplatTypeLabel } from '../../domain/splatConstants';

function SplatsDefinitionsToolbar({
  splatTypeFilter,
  onSplatTypeFilterChange,
  splatActiveFilter,
  onSplatActiveFilterChange,
  loading,
  onOpenAdd,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 2,
        mb: 2,
        width: '100%',
      }}
    >
      <FormControl size="small" sx={{ minWidth: 220 }}>
        <InputLabel id="splat-definitions-type-filter-label">
          Splat type
        </InputLabel>
        <Select
          labelId="splat-definitions-type-filter-label"
          label="Splat type"
          value={splatTypeFilter}
          onChange={onSplatTypeFilterChange}
          disabled={loading}
        >
          <MenuItem value="">All types</MenuItem>
          {SPLAT_TYPES.map((splatType) => (
            <MenuItem key={splatType} value={splatType}>
              {getSplatTypeLabel(splatType)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="splat-definitions-active-filter-label">
          Status
        </InputLabel>
        <Select
          labelId="splat-definitions-active-filter-label"
          label="Status"
          value={splatActiveFilter}
          onChange={onSplatActiveFilterChange}
          disabled={loading}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="inactive">Inactive</MenuItem>
        </Select>
      </FormControl>
      <Button variant="contained" onClick={onOpenAdd} sx={{ ml: 'auto' }}>
        Add Splat
      </Button>
    </Box>
  );
}

/**
 * Splat Definitions tab: type and status filters, add action, and definitions list or loading state.
 */
function SplatsDefinitionsTab({
  loading,
  error,
  splatTypeFilter,
  onSplatTypeFilterChange,
  splatActiveFilter,
  onSplatActiveFilterChange,
  onOpenAdd,
  splats,
  emptyMessage,
  splatIdToName,
  eventIdToName = new Map(),
  imageUrlByName,
  onEdit,
  onDelete,
  canDeleteSplat,
  getDeleteDisabledReason,
}) {
  const tableSection = loading ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 4,
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      {error ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      ) : null}
      <SplatsTable
        splats={splats}
        emptyMessage={emptyMessage}
        splatIdToName={splatIdToName}
        eventIdToName={eventIdToName}
        imageUrlByName={imageUrlByName}
        onEdit={onEdit}
        onDelete={onDelete}
        canDeleteSplat={canDeleteSplat}
        getDeleteDisabledReason={getDeleteDisabledReason}
      />
    </>
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      <SplatsDefinitionsToolbar
        splatTypeFilter={splatTypeFilter}
        onSplatTypeFilterChange={onSplatTypeFilterChange}
        splatActiveFilter={splatActiveFilter}
        onSplatActiveFilterChange={onSplatActiveFilterChange}
        loading={loading}
        onOpenAdd={onOpenAdd}
      />
      {tableSection}
    </Container>
  );
}

export default SplatsDefinitionsTab;
